export default {
  background_image: 'Achtergrondafbeelding',
  file_too_large: 'Het bestand is te groot. De maximale grootte is {{max}} MB.',
  upload_failed: 'Uploaden mislukt. Probeer het opnieuw.',
};
